import { axiosInstanceCRMV2 } from "./instance";

export const createDealByQr = (data) => {
    return axiosInstanceCRMV2.post("/crm_deal/create/by-qr", data);
};